<template>
  <v-app-bar app color="white" clipped-left style="z-index: 101; height: 64px">
    <v-img
      class="hidden-xs-only mx-10 px-2"
      align="center"
      justify="center"
      :transition="false"
      :src="
        require(`@/assets/${this.$store.getters.getLogo.path}/logo-nav.png`)
      "
      max-height="100"
      max-width="110"
      lazy-src
    />
    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-sm-and-down">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="btn-text--collapsed" text>
            <!-- <v-icon class="ml-1">mdi-account</v-icon> -->
            {{ getMe.user.username }}
            <v-icon class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in subMenus"
            :key="index"
            link
            active-class="navigation-buttons--active"
            @click="routeSubmenu(item)"
          >
            <v-list-item-action>
              {{ item.title }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <v-toolbar-items class="hidden-md-and-up my-auto">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="btn-text--collapsed" text>
            <v-icon class="ml-1">mdi-account</v-icon>
            <v-icon class="ml-1">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title class="font-weight-bold">{{
              getMe.user.username
            }}</v-list-item-title>
          </v-list-item>
          <template v-for="(item, index) in subMenus" link>
            <v-list-item-title :key="index" @click="routeSubmenu(item)">
              <v-btn class="btn-text--collapsed body-1" text>{{
                item.title
              }}</v-btn>
            </v-list-item-title>
          </template>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import restrictions from "../../utils/restrictions";
export default {
  data: () => ({
    subMenus: [],
    drawer: null,
  }),
  created() {
    this.setSubMenus();
  },

  methods: {
    setSubMenus() {
      this.subMenus = [
        {
          title: this.$t("components.navigationBar.topBar.logout"),
          routeName: "logout",
          visible: true,
          children: [],
          disabled: false,
        },
      ];
    },

    routeSubmenu(menu) {
      if (menu.routeName === "logout") {
        this.$store.dispatch(AUTH_LOGOUT);
        this.$router.push({ path: "/login" });
        return;
      }

      console.error("Insufficient route", JSON.stringify(menu));
    },
  },

  computed: {
    ...mapGetters([
      "isAuthenticated",
      "getMe",
      "getIframeStatus",
      "getTheme",
      "getShowNotificationBadge",
    ]),
  },
};
</script>

<style scoped>
.btn-text--collapsed {
  text-transform: none;
}
.btn--align {
  margin: auto;
  width: 50%;
}
.grey--text {
  color: rgba(0, 0, 0, 0.6);
}
.navigation-buttons--active {
  background-color: var(--navigation-bar-background-color) !important;
  color: var(--navigation-bar-color) !important;
}
</style>
